module.exports = __webpack_public_path__ + "static/media/shelter_seaplaneport_marker.229a2b95.svg";